class GoogleMap extends HTMLElement {
  map; latitude; longitude; zoom; bounds;

  constructor() {
    super();
    this.latitude = Number(this.dataset.latitude) || 0;
    this.longitude = Number(this.dataset.longitude) || 0;
    this.zoom = parseInt(this.dataset.zoom) || 3;

    this.init();
  }

  init = () => {
    // Crea una mappa Google nella posizione specificata
    this.map = new google.maps.Map(this, {
      center: { lat: this.latitude, lng: this.longitude},
      mapTypeId: 'roadmap',
      zoom: this.zoom,
      streetViewControl: false,
      mapId: this.dataset.id
    });

    // Emette un evento quando i bounds della mappa cambiano (es. dopo zoom/pan)
    // Usato dal StoreLocator per filtrare i negozi visibili
    this.map.addListener('bounds_changed', () => {
      this.bounds = this.map.getBounds();
      this.dispatchEvent(new CustomEvent(Utils.E_MAP_BOUNDS_CHANGED, {detail: this.bounds}));
    });
  }

  center = (latitude, longitude) => {
    this.latitude = latitude;
    this.longitude = longitude;
    this.map.setCenter({ lat: latitude, lng: longitude });
  }

  setLocation = (location) => {
    this.map.setCenter(location);
  }

  setZoom = (zoom) => {
    this.zoom = zoom;
    this.map.setZoom(zoom);
  }
}
if (!customElements.get('google-map')) {
  customElements.define('google-map', GoogleMap);
}

class LocatorStore extends HTMLElement {
  latitude; longitude; marker; info; defaultMarker; selectedMarker;
  static classes = {
    hidden: 'd-none'
  }

  constructor() {
    super();
    this.init();
  }

  init = () => {
    this.latitude = Number(this.dataset.latitude) || 0;
    this.longitude = Number(this.dataset.longitude) || 0;
    this.info = document.querySelector(this.dataset.info);

    // Prepara due versioni dell'icona marker: default e selezionato
    // La verranno cambiate dinamicamente quando il negozio è selezionato
    this.defaultMarker = document.createElement('img');
    this.defaultMarker.src = this.dataset.marker;
    this.defaultMarker.alt = this.dataset.title || '';

    this.selectedMarker = document.createElement('img');
    this.selectedMarker.src = this.dataset.markerSelected;
    this.selectedMarker.alt = this.dataset.title || '';

    // Quando l'utente clicca sul negozio, mostra le info e cambia l'icona
    this.addEventListener('click', () => this.showInfo());
    // Quando l'utente chiude le info, ripristina l'icona di default
    this.info.addEventListener(Utils.E_STORE_UNSELECTED, () => this.hideInfo());
  }

  showInfo = () => {
    if(this.info)
      this.info.show();

    this.marker.content = this.selectedMarker;
    this.dispatchEvent(new CustomEvent(Utils.E_STORE_SELECTED, {detail: this}));
  }

  hideInfo = () => {
    this.marker.content = this.defaultMarker;
  }

  setMarker = (map) => {
    this.marker = new google.maps.marker.AdvancedMarkerElement({
      position: {lat: this.latitude, lng: this.longitude},
      title: this.dataset.title,
      map: map,
      content: this.defaultMarker,
      // 2.1.1: dichiara il marker come controllo interattivo all'API Google,
      // che così gli assegna role="button" e l'attivazione da tastiera
      // (Invio/Spazio emettono sia 'gmp-click' sia il 'click' legacy usato sotto).
      gmpClickable: true
    });
    this.marker.addListener('click', () => this.showInfo());
    this.setMarkerFocusable();
  }

  // 2.1.1: l'API Google gestisce i marker come gruppo con roving tabindex, cioè
  // un solo marker per volta ha tabindex="0" e tutti gli altri tabindex="-1"
  // (si scorrono con le frecce). Qui ogni marker viene reso un tab stop
  // autonomo, così è raggiungibile singolarmente con il solo Tab.
  setMarkerFocusable = () => {
    const element = this.marker && this.marker.element;
    if (element && element.getAttribute('tabindex') !== '0')
      element.setAttribute('tabindex', '0');
  }

  isInBounds = (bounds) => {
    return bounds.contains(new google.maps.LatLng(this.latitude, this.longitude));
  }

  hide = () => {
    this.classList.add(LocatorStore.classes.hidden);
  }

  show = () => {
    this.classList.remove(LocatorStore.classes.hidden);
  }

}
if (!customElements.get('locator-store')) {
  customElements.define('locator-store', LocatorStore);
}

class LocatorStoreInfo extends HTMLElement {
  stores
  static classes = {
    hidden: 'd-none'
  }

  constructor() {
    super();
    this.init();
  }

  init = () => {
    this.stores = document.querySelectorAll('locator-stores');
  }

  hide = () => {
    this.classList.add(LocatorStoreInfo.classes.hidden);
    this.stores.forEach(store => store.show());
    this.dispatchEvent(new CustomEvent(Utils.E_STORE_UNSELECTED, {detail: null}));
  }

  show = () => {
    document.querySelectorAll('locator-store-info').forEach(info => info.hide());
    this.classList.remove(LocatorStoreInfo.classes.hidden);
    this.stores.forEach(store => store.hide());
  }
}
if (!customElements.get('locator-store-info')) {
  customElements.define('locator-store-info', LocatorStoreInfo);
}

class LocatorStoreBack extends HTMLElement {
  info;

  constructor() {
    super();
    this.init();
  }

  init = () => {
    this.info = this.closest('locator-store-info');
    this.addEventListener('click', () => this.hideInfo());
    // Operabilità da tastiera: Invio/Spazio attivano il "back" (role="button")
    this.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.hideInfo();
      }
    });
  }

  hideInfo = () => {
    this.info.hide();
  }
}
if (!customElements.get('locator-store-back')) {
  customElements.define('locator-store-back', LocatorStoreBack);
}

class LocatorStores extends HTMLElement {
  static classes = {
    hidden: 'd-none'
  }

  constructor() {
    super();
    this.init();
  }

  init = () => {
  }

  hide = () => {
    this.classList.add(LocatorStoreInfo.classes.hidden);
  }

  show = () => {
    this.classList.remove(LocatorStoreInfo.classes.hidden);
  }
}
if (!customElements.get('locator-stores')) {
  customElements.define('locator-stores', LocatorStores);
}

class StoreLocator extends HTMLElement {
  map; search; stores; button;

  constructor() {
    super();
    this.init();
  }

  init = () => {
    this.map = this.querySelector('google-map');
    this.search = this.querySelector('input-places');
    this.stores = this.querySelectorAll('locator-store');
    this.button = this.querySelector('[data-search]');

    // Centra la mappa sulla posizione geolocalizzata dell'utente
    window.addEventListener(Utils.E_PLACES_GEOLOCATED, (e) => {
      this.centerMap(e.detail.coords.latitude, e.detail.coords.longitude);
    });
    
    // Centra la mappa sul luogo cercato dall'utente
    this.search.addEventListener(Utils.E_PLACES_CHANGED, (e) => {
      this.locationMap(e.detail[0].geometry);
    });
    
    // Filtra i negozi visibili in base ai bounds della mappa (quando l'utente fa zoom/pan)
    this.map.addEventListener(Utils.E_MAP_BOUNDS_CHANGED, (e) => {
      this.filterStores(e.detail);
    });
    
    // Permette di ripetere la ricerca senza dover digitare di nuovo
    this.button.addEventListener('click', () => {
      this.retriggerSearch();
    });
    
    // Crea i marker sulla mappa per tutti i negozi
    this.setMarkers();
  }

  retriggerSearch = () => {
    this.querySelectorAll('locator-store-info').forEach(info => info.hide());
    this.locationMap(this.search.getPlaces()[0].geometry);
  }

  setMarkers = () => {
    this.stores.forEach(store => {
      store.setMarker(this.map.map);
      store.addEventListener(Utils.E_STORE_SELECTED, (e) => {
        this.centerMap(store.latitude, store.longitude);
        this.map.setZoom(15);
      });
    });

    // 2.1.1: Google riassegna i tabindex ogni volta che ridisegna i marker
    // (pan, zoom, spostamento del focus), riportando a "-1" tutti tranne uno.
    // Li rendiamo di nuovo tab stop quando la mappa si è fermata.
    this.map.map.addListener('idle', () => this.restoreMarkersFocusable());
  }

  restoreMarkersFocusable = () => {
    this.stores.forEach(store => store.setMarkerFocusable());
  }

  filterStores = (bounds) => {
    this.stores.forEach(store => {
      if(store.isInBounds(bounds)){
        store.show();
      } else {
        store.hide();
      }
    });
  }

  centerMap = (latitude, longitude) => {
    this.map.center(latitude, longitude);
  }

  locationMap = (geometry) => {
    if(geometry && geometry.location)
      this.map.setLocation(geometry.location);
    console.log('locationMap');
    this.map.setZoom(12);
  }
}
if (!customElements.get('store-locator')) {
  customElements.define('store-locator', StoreLocator);
}